import React, { useState, useEffect } from "react";
import themePropTypes from "../theme-prop-types";

const Loader = ({ text, textDelay = 0, isHidden }) => {
  const [textVisible, setTextVisible] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setTextVisible(true), textDelay);
    return () => clearTimeout(timeout);
  }, [textDelay, setTextVisible]);

  const showText = text && textVisible;

  return (
    !isHidden && (
      <>
        <div className='loader-web-sdk' />
        <div aria-live='assertive'>
          {showText && <div className='loader-text-web-sdk'>{text}</div>}
        </div>
      </>
    )
  );
};

Loader.propTypes = themePropTypes.loader;

export default Loader;
